const sections = [
  {
    id: 0,
    title: "How to reach Guwahati?",
    content:
      "Guwahati is the gateway for North East India. It is well connected by air, rail and road with the rest of the country. Trains from all parts of the country are available to reach Guwahati (visit the Indian Railways Official website for more details). There are direct flights from Delhi, Kolkata and Mumbai. There are direct or connecting flights from Jaipur, Chennai, Hyderabad, Bengaluru to Guwahati via Kolkata / Delhi. Air India, Jet Airways, IndiGo, SpiceJet and GoAir operate regular flights to and from Guwahati.",
  },
  {
    id: 1,
    title: "How to reach the Institute from Guwahati Railway Station?",
    content:
      "The institute is located at a distance of 18 kilometres from the Guwahati Railway Station (GHY). The institute provides a bus service with buses plying from the institute to the city and back at regular intervals.",
  },
  {
    id: 2,
    title: "How to reach the Institute from Kamakhaya Railway Station?",
    content:
      "Kamakhya Railway Station is another major station in Guwahati. Transportation options are available to reach the institute from this station.",
  },
  {
    id: 3,
    title: "How to reach the Institute from Guwahati Airport?",
    content:
      "The institute is located at a distance of 18 kilometres from the Guwahati Airport. The institute does not provide any bus service for the airport. Prepaid taxis and cabs can be availed of directly from Guwahati Airport to reach the institute.",
  },
  {
    id: 4,
    title: "What all should we get or not get from home?",
    content:
      "You will need essentials like a lock, a bucket, a mug, a mattress (6'x 3'), a pillow, blanket, curtains, hangers, umbrella and a scientific calculator. A bicycle is advised since the campus is quite large. Don't get worked up about how to carry all this – we have a solution for that too. All these can be bought from Guwahati city to which IIT buses ply at regular intervals.",
  },
  {
    id: 5,
    title:
      "Should we bring our JEE preparation books, in case they are useful in the basic Physics and Chemistry courses?",
    content:
      "There would be some courses in the first year requiring basic knowledge of mechanics, electrostatics, thermodynamics and a bit of organic and physical chemistry. You'll do some of them in the first semester, others in the second. Such courses generally start with basics of these topics and then go into further detail.",
  },
  {
    id: 6,
    title: "Which banks have their branches in IIT Guwahati?",
    content:
      "There are 3 major banks in the campus: Canara Bank (IFSC: CNRB0008652, MICR Code: 781015008), State Bank of India (IFSC: SBIN0014262, MICR Code: 781002053) and ICICI (IFSC: ICIC0003325) bank. You are advised to have an account in SBI or Canara Bank for quick payments and receiving from the Institute.",
  },
  {
    id: 7,
    title:
      "Where do we stay once we arrive IIT Guwahati? Where can my parents stay?",
    content:
      "A limited number of rooms (60 rooms) are available at IIT Guwahati Guest House that can be provided for temporary accommodation (on payment basis) for Parents/ Guardians accompanying their wards for admission at IIT Guwahati.",
  },
  {
    id: 8,
    title:
      "How are the hostels allotted to freshmen? Does my hostel change every year?",
    content:
      "The hostel room is made available to the students on their arrival. Hostels are allotted randomly by the administration. Once you have been allotted a hostel, you stay there for your entire IIT life unless some special and extreme circumstances arise.",
  },
  {
    id: 9,
    title:
      "Is there any ragging at IIT Guwahati? What are the steps that IIT Guwahati is taking?",
    content:
      "IIT Guwahati has a zero tolerance policy. We do not accept ragging in any form. If you ever find yourself in a situation where you feel uncomfortable, contact anti ragging hotline number: 08011089898.",
  },
  {
    id: 10,
    title: "Are girls allowed to enter boys hostels and vice-versa?",
    content:
      "Residents of the opposite sex are prohibited from entering the flats/units of the hostel residents at all times. You may use the common area such as the Mess, Hostel Office or Reading room/Library for any discussion and/or group study.",
  },
  {
    id: 11,
    title: "What are the timings of library?",
    content:
      "Library is open from 9:00 AM to 2:00 AM, although books can be issued from 9:00 AM to 5:00 PM only (working days). Library is open 24hrs. during mid semester and end semester examinations.",
  },
  {
    id: 12,
    title:
      "What are the scholarships/financial assistance available for studying at IIT Guwahati?",
    content:
      "Scholarships are offered to most students by the Institute, government agencies, alumni and corporations. This assistance is offered on the basis of Merit-cum-Means, performance, special capabilities etc.",
  },
  {
    id: 13,
    title: "Can I change my department post-admission?",
    content:
      "Students who do very well in their first year are allowed to change their department. A Branch Change is made strictly on basis of Cumulative Performance Index (academic performance) at end of second semester.",
  },
  {
    id: 14,
    title: "What are minor courses? And what are their advantages?",
    content:
      "Minor Courses are efficiently designed course structures which provides you an insight and fundamental concepts of the branch you choose as your minor. You can choose minor on following topics and branches: Computer Science and Engineering, Electronics & Electrical Engineering, Mechanical Engineering, Civil Engineering, Biotechnology, Chemical Engineering, Engineering Physics, Chemical Science & Technology, Mathematics, South and Southeast Asian Studies, Language and Literature.",
  },
  {
    id: 15,
    title: "How can I take a minor course? And Can I drop minor course?",
    content:
      "Yes, there is a criteria for getting a minor course, you must have CGPA of 6.5 or above in first two semesters. The number of seats in each minor discipline will be as per decision of the Senate of IIT Guwahati.",
  },
  {
    id: 16,
    title: "What is the internet policy at IIT Guwahati?",
    content:
      "IIT Guwahati has LAN cables installed in every hostel room and WIFI routers in the Academic Area, Student Activity Centre (SAC) and your respective hostels. IIT Guwahati believes in providing high speed internet to all its students.",
  },
  {
    id: 17,
    title: "Are there any options nearby for food other than the hostel mess?",
    content:
      "Institute offers delectable food services so that the brains at work can perform their best. Although home cooked food cannot be replaced by anything, the campus does have alternatives if you want to skip the mess food. The campus houses various renowned restaurant franchises like Baskin and Robbins and Subway in Food Court adjoining the New SAC building.",
  },
  {
    id: 18,
    title: "What are the medical facilities provided in IIT Guwahati?",
    content:
      "We have an in-campus hospital at IIT Guwahati, which is open 24×7. In case of emergency the IIT Guwahati ambulance drives you to the hospital. You call them directly or approach the nearest security desk to summon them.",
  },
];

export default sections;
